module.exports = __webpack_public_path__ + "img/primary-product-image-icon.ddbddc9f.svg";